<template>
  <div class="contactform">
    <h1>Formulario de Contacto</h1>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form autocomplete="off" @submit.prevent="passes(handleSubmit)">
        <div>
          <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
            <label for="CPname">Nombre</label>
            <input type="text" id="CPname" name="CPname" autocomplete="nope"
              v-model="datasForm.name"
            >
            <label class="error">{{errors[0]}}</label>
          </ValidationProvider>
        </div>
        <div>
          <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
            <label for="CPemail">Email</label>
            <input type="email" id="CPemail" name="CPemail" autocomplete="nope"
              v-model="datasForm.email"
            >
            <label class="error">{{errors[0]}}</label>
          </ValidationProvider>
        </div>
        <div>
          <ValidationProvider name="Subject" rules="required" v-slot="{ errors }">
            <label for="CPsubject">Asunto</label>
            <input type="text" id="CPsubject" name="CPsubject" autocomplete="nope"
              v-model="datasForm.subject"
            >
            <label class="error">{{errors[0]}}</label>
          </ValidationProvider>
        </div>
        <div>
          <ValidationProvider name="Message" rules="required" v-slot="{ errors }">
            <label for="CPmessage">Mensaje</label>
            <textarea id="CPmessage" name="CPmessage" rows="8"
              v-model="datasForm.message"
            />
            <label class="error">{{errors[0]}}</label>
          </ValidationProvider>
        </div>
        <div style="text-align: center;">
          <button type="submit"
            :class="{Berror: ButtonCode === 2, Bdone: ButtonCode === 1,
              Bdisabled: ButtonCode === 3}"
            :disabled="ButtonCode > 0"
          >
            <i class="icofont-clock-time" v-show="ButtonCode === 3" />
            <i class="icofont-exclamation-tringle" v-show="ButtonCode === 2" />
            <i class="icofont-verification-check" v-show="ButtonCode === 1" />
            {{ button[(ButtonCode || 0)] }}
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import axios from 'axios';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import '../utils/validations';

export default {
  name: 'ContactForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      ButtonCode: 0,
      FormSended: null,
      datasForm: {},
      button: {
        0: 'Enviar',
        1: 'Mensaje Enviado',
        2: 'Error al enviar el formulario',
        3: 'Formulario deshabilitado temporalmente',
      },
    };
  },
  methods: {
    // Error Code (1 = OK, 2 = Error, 3 = Disabled)
    SetButtonMsg(code = 1) {
      if (code === 3) {
        this.ButtonCode = 3;
      } else if (code === 2) {
        this.ButtonCode = 2;
        setTimeout(() => { this.ButtonCode = 0; }, 3000);
      } else {
        this.ButtonCode = 1;
        this.datasForm = {};
        setTimeout(() => { this.ButtonCode = 0; }, 3000);
      }
    },
    handleSubmit() {
      this.Submiting = true;
      axios({
        method: 'post',
        url: 'https://fmm2i84ov0.execute-api.eu-west-1.amazonaws.com/FormSendMail',
        data: {
          name: this.datasForm.name,
          email: this.datasForm.email,
          subject: this.datasForm.subject,
          message: this.datasForm.message,
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.SetButtonMsg(1);
          } else {
            this.SetButtonMsg(2);
          }
        })
        .catch((err) => {
          if (err.response.data.msg === 'Disabled') {
            this.SetButtonMsg(3);
          } else {
            this.SetButtonMsg(2);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .contactform {
    color: $dorado;
    background-color: $background;
    padding: 20px 0 20px;
    text-align: center;
    margin: 20px 0 20px 0;
    form {
      margin: auto 0;
      display: inline-block;
      width: 100%;
      max-width: 1400px;
      text-align: center;
      div {
        margin: 5px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
        width: 90%;
        @media only screen and (min-width: 1000px) {
          width: 51%;
        }
        input, textarea, button {
          font-size: 16px;
          width: 100%;
          padding: 7px 0px 7px 0px;
          margin: 5px 0 2px;
          border: 1px solid $dorado;
          resize: none;
          &:focus {
            border: 1px solid $dorado;
          }
        }
        button[type="submit"] {
          background-color: $background;
          width: 50%;
          color: $dorado;
          cursor: pointer;
          &:hover:not([disabled]) {
            color: $dorado;
          }
          &.Bdisabled {
            background-color: #ccc;
            color: #000;
          }
          &.Berror {
            background: #fef4f6;
            color: #f0506e;
          }
          &.Bdone {
            background: #edfbf6;
            color: #32d296;
          }
        }
        .error {
          font-size: 12px;
          font-weight: 400;
          color: red;
        }
      }
    }
  }
</style>
